export default __webpack_public_path__ + "static/sedan-soueast-3a7f77c80c9a4b7b2862b6d0b3a6f71a.png";